import { call, put, takeLatest } from 'redux-saga/effects';
import HeroAccountAPI from 'api-services/HeroAccountApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { checkUserHelper } from '../utils/helperSagas';
import { SET_PHONE, VERIFY_PHONE } from './actionTypes';
import { setPhoneDone, setPhoneError, verifyPhoneDone, verifyPhoneError } from './actionCreators';
import { logout } from '../auth/actionCreators';
export function* setPhone(constAccessParams, action) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroAccountAPI.setMobile, newAccessParams, action.data.mobile, action.data.is_landline);
    if (isSuccessResponse(result)) {
        yield put(setPhoneDone(action.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(setPhoneError(result.msg));
    }
}
export function* watchSetPhoneCalls(constAccessParams) {
    yield takeLatest(SET_PHONE, setPhone, constAccessParams);
}
export function* verifyPhone(constAccessParams, action) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroAccountAPI.confirmMobile, newAccessParams, action.data.mobile, String(action.data.pin));
    if (isSuccessResponse(result)) {
        yield put(verifyPhoneDone());
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(verifyPhoneError(result.msg));
    }
}
export function* watchVerifyPhoneCalls(constAccessParams) {
    yield takeLatest(VERIFY_PHONE, verifyPhone, constAccessParams);
}
//# sourceMappingURL=saga.js.map